import { useLocation } from 'react-router-dom';
import { ApiPayProdGeneralList, ApiPayReady } from 'api/Pay';
import { appSetClose, isApp } from 'utils/AppUtil';
import { runPopupBookpalBankOrder, runPopupBookpalBankOrderInfo } from 'utils/Common';

import ComponentCoupon from '../component/ComponentCoupon';
import ComponentPay from '../component/ComponentPay';

import style from '../style/Order.module.scss';


import img_rating_label_normal from 'assets/images/rating_label_normal.svg';
import img_rating_label_vip from 'assets/images/rating_label_vip.svg';
import img_rating_label_vip_silver from 'assets/images/rating_label_vipSilver.svg';
import img_rating_label_vip_gold from 'assets/images/rating_label_vipGold.svg';
import img_rating_label_rvip from 'assets/images/rating_label_rVip.svg';

import img_kakao_logo from 'assets/images/order/kakao_logo.png';
import img_naver_logo from 'assets/images/order/naver_logo.png';
import img_payco_logo from 'assets/images/order/payco_logo.png';

import img_charge_banner1 from 'assets/images/order/charge_banner1.png';
import img_charge_banner2 from 'assets/images/order/charge_banner2.png';
import { useEffect, useState } from 'react';

function CloseOrder(){

    const location = useLocation();
    const [prodList, setProdList] = useState(null);
    const [selectProd, setSelectProd] = useState(null);

    const [payList, setPayList] = useState(null);
    const [selectPay, setSelectPay] = useState(null);
    const [selectPayPrice, setSelectPayPrice] = useState(null);

    const [vbank, setVbank] = useState(null);

    const [payHidden, setPayHidden] = useState(true);

    const [isPaySubmit, setIsPaySubmit] = useState(false);

    const handlerClose = () => {
        if(isApp()){
            appSetClose();
        }

        window.close();
    }


    return (
        <>
            <div className={"tit_con section clearfix " + style['tit_con'] } style={{height:"auto",letterSpacing:"0.5px", lineHeight:"1.3"}}>
                <div className={"grade_up top_con radius-sm red_opacity-05 bg " + style['grade_up'] + " " + style['top_con'] + " " + style['bg']} style={{padding:"10px",backgroundColor:"#eee"}}>
                    <p className={"title body-01 color-txt-muted " + style['title']}><span className="title-01-b color-txt-normal" style={{fontSize:"0.85rem"}}>
                        
                    북팔 플랫폼 서비스가 종료됨에 따라
                    추가 쿠폰 구매 및 충전이 불가능합니다.<br />
                    그동안 북팔을 이용해 주셔서 진심으로 감사드립니다.
                    </span>
                    {/* 매월 1일, 최근 3개월 결제금액에 따라 결정됩니다. */}
                    </p>
                </div>
            </div>
            <div className="fixed_button">
                <button 
                    type="button" 
                    className="button btn_01 filled btn-05 white-always txt" 
                    // disabled={!isPaySubmit}
                    onClick={handlerClose}
                    >확인</button>
            </div>
        </>
    );
}



export default CloseOrder;